import { render, staticRenderFns } from "./ProductDetailsInfo.vue?vue&type=template&id=478164b3&scoped=true"
import script from "./ProductDetailsInfo.vue?vue&type=script&lang=js"
export * from "./ProductDetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsInfo.vue?vue&type=style&index=0&id=478164b3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478164b3",
  null
  
)

export default component.exports